import { lazy, Suspense, ComponentType } from "react";
import LoadingPage from "../../components/Loading/LoadingPage";
import { Navigate } from "react-router-dom";

// Lazy load all components
const AdminLayout = lazy(() => import("../layout/AdminLayout"));
const Dashboard = lazy(() => import("../pages/Dashboard"));
const Personnel = lazy(() => import("../pages/Personnel"));
const Customers = lazy(() => import("../pages/Customers"));
const Product = lazy(() => import("../pages/Product"));
const Reports = lazy(() => import("../pages/Reports"));
const SingleReports = lazy(() => import("../pages/SingleReports"));
const RepReport = lazy(
  () =>
    import(
      "../components/reports/single_reports/salesRepDet/rep_report/RepReport"
    )
);
const AllReports = lazy(() => import("../pages/AllReports"));
const AllSalesReps = lazy(() => import("../pages/AllSalesReps"));
const CreateManager = lazy(() => import("../pages/CreateManager"));
const CreateSalesRep = lazy(() => import("../pages/CreateSalesRep"));
const Profile = lazy(() => import("../../salesRep/pages/Profile"));

// Type definition for LazyComponent props
interface LazyComponentProps {
  component: ComponentType;
}

// Wrap component with Suspense
const LazyComponent = ({ component: Component }: LazyComponentProps) => (
  <Suspense fallback={<LoadingPage />}>
    <Component />
  </Suspense>
);

const AdminRoutes = [
  {
    path: "/admin/:name",
    element: <LazyComponent component={AdminLayout} />,
    errorElement: <Navigate to="/" replace />,
    children: [
      {
        index: true,
        element: <LazyComponent component={Dashboard} />,
      },
      {
        path: "dashboard",
        element: <LazyComponent component={Dashboard} />,
      },
      {
        path: "personnel",
        element: <LazyComponent component={Personnel} />,
      },
      {
        path: "customers",
        element: <LazyComponent component={Customers} />,
      },
      {
        path: "product",
        element: <LazyComponent component={Product} />,
      },
      {
        path: "report",
        element: <LazyComponent component={Reports} />,
      },
      {
        path: "report/:name",
        element: <LazyComponent component={SingleReports} />,
      },
      {
        path: "report/:rep/:salesRepID",
        element: <LazyComponent component={RepReport} />,
      },
      {
        path: "report/reports/all/:salesRepID",
        element: <LazyComponent component={AllReports} />,
      },
      {
        path: "salesreps/:manager",
        element: <LazyComponent component={AllSalesReps} />,
      },
      {
        path: "create-manager",
        element: <LazyComponent component={CreateManager} />,
      },
      {
        path: "create-salesRep",
        element: <LazyComponent component={CreateSalesRep} />,
      },
      {
        path: "profile",
        element: <LazyComponent component={Profile} />,
      },
    ],
  },
];

export default AdminRoutes;
